module.exports = __webpack_public_path__ + "static/media/github.6249536d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/github.svg
// module id = 112
// module chunks = 0